<template>
  <footer :class="['footer',  _isMobile()?'mobile':'']">
      <div v-html="tenantInfo && tenantInfo.footer"></div>
  </footer>
</template>
<script>
import Vue from "vue";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: "Footer",
  mixins: [mixinDevice],
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = this.$store.getters.tenantInfo
  },
};
</script>
<style lang="less" scoped>
.mobile{
  padding-left:25px;
  padding-right:25px;
  min-height: 120px!important;
}
footer {
  color: white;
  width: 100%;
  min-height: 150px;
  bottom:0;
  padding-top: 40px;
  padding-bottom: 15px;
  text-align: center;
}
.logo{
  max-width:200px
}
</style>